export default __webpack_public_path__ + "static/media/event.inline.092c2733.svg";